import { chakra, Divider, Heading, Image, Link, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import structuredData from 'Assets/svg/deep-learning.svg';
import videoChat from 'Assets/svg/video-chat.svg';
import management from 'Assets/svg/management.svg';
import marketing from 'Assets/svg/marketing.svg';
import referrral from 'Assets/svg/referral-program.svg';
import affiliateMarketing from 'Assets/svg/affiliate-marketing.svg';
import chatBubbles from 'Assets/svg/chat-bubbles.svg';
import React from 'react';
import { IHowItWorksLocalizationDocument } from 'Types/Interface/Sanity';
import { AppRoutes } from 'Routes/AppRoutes';

interface ICampaignProps {
	howItWorksLocalization: IHowItWorksLocalizationDocument | null
}


export const Campaigns = ({howItWorksLocalization}:ICampaignProps) => {
	const campaigns = [
		{
			id: 0,
			type: howItWorksLocalization?.campaignItems[0],
			icon: structuredData,
			text: howItWorksLocalization?.campaignItemsDescriptions[0]
		},
		{
			id: 1,
			type: howItWorksLocalization?.campaignItems[1],
			icon: videoChat,
			text: howItWorksLocalization?.campaignItemsDescriptions[1]
		},
		{
			id:2,
			type: howItWorksLocalization?.campaignItems[2],
			icon: management,
			text: howItWorksLocalization?.campaignItemsDescriptions[2]
		},
		{
			id:3,
			type: howItWorksLocalization?.campaignItems[3],
			icon: affiliateMarketing,
			text: howItWorksLocalization?.campaignItemsDescriptions[3]
		},
		{
			id:4,
			type: howItWorksLocalization?.campaignItems[4],
			icon: referrral,
			text: howItWorksLocalization?.campaignItemsDescriptions[4]
		},
		{
			id:5,
			type: howItWorksLocalization?.campaignItems[5],
			icon: marketing,
			text: howItWorksLocalization?.campaignItemsDescriptions[5]
		},
		{
			id:6,
			type: howItWorksLocalization?.campaignItems[6],
			icon: chatBubbles,
			text: howItWorksLocalization?.campaignItemsDescriptions[6]
		},
	];

	return(
		<Stack spacing={['30px','50px']} >
			<Stack spacing={'20px'}>
				<Heading textTransform={'uppercase'} fontWeight={'bold'} fontSize={['30px','40px']}>Use the connections with <chakra.span color={'darkCoral'}>Engagement Campaigns</chakra.span></Heading>
				<Text w={['100%', null, null,'955px']} fontSize={'16px'}  color={'#525252'}>Leverage Loop’s diverse engagement campaigns to capture insights, build loyalty, and drive retention.</Text>
			</Stack>
			
			<SimpleGrid gap={['20px','40px']} columns={[2, null, null, 3, 4]}>
				{
					campaigns.map((campaign) => {
						return(
							<VStack align={'flex-start'} key={campaign.id} spacing={['30px','20px']} >
								<Image src={campaign.icon} boxSize={'30px'} />
								<Divider w={['90%','280px']} borderColor={'#264653'}/>
								<Heading textTransform={'uppercase'} fontSize={['16px','18px']} fontWeight={'bold'}>
									{campaign.type?.includes('Meet ECHO') && campaign.type
										? campaign.type.split('Meet ECHO').map((part, index, arr) => (
											<React.Fragment key={index}>
												{part}
												{index < arr.length - 1 && (
													<Link href={AppRoutes.Echo} color={'#00A0E9'}>
														Meet ECHO
													</Link>
												)}
											</React.Fragment>
										))
										: campaign.type
									}
								</Heading>
								<Text fontSize={['16px','16px']} >{campaign.text}</Text>
							</VStack>
						);
					})
				}
			</SimpleGrid>
		</Stack>
	);
};